export const externals = {
  linkedin: "https://www.linkedin.com/in/sangthanh052/",
  github: "https://github.com/sangthanh052/",
  email: "mailto:sangthanh052@gmail.com/",
  leetcode: "https://leetcode.com/u/shangdev/",
};

export const internal = {
  home: "/",
  email: "/email",
  cv: "/cv",
};
